import styled, { css, keyframes } from 'styled-components';
import { ChevronIcon } from '@sainsburys-tech/bolt-icons';
var slideFromTheRight = keyframes(["0%{transform:translateX(100%);}100%{transform:translateX(0%);}"]);
var slideFromTheLeft = keyframes(["0%{transform:translateX(-100%);}100%{transform:translateX(0%);}"]);
var slideToTheLeft = keyframes(["0%{transform:translateX(-100%);visibility:visible;}100%{transform:translateX(-200%);}"]);
var slideToTheRight = keyframes(["0%{transform:translateX(-100%);visibility:visible;}100%{transform:translateX(100%);}"]);
var Slider = styled.div.withConfig({
  displayName: "Sliderstyles__Slider",
  componentId: "sc-1w0ebdo-0"
})(["position:relative;width:100%;max-width:100%;overflow:hidden;"]);
var Slide = styled.div.withConfig({
  displayName: "Sliderstyles__Slide",
  componentId: "sc-1w0ebdo-1"
})(["flex:1 1 0;display:flex;order:3;width:100%;height:100%;visibility:hidden;justify-content:center;", " ", " ", " ", " ", ""], function (props) {
  return props.transitionSpeed === 'slow' && css(["animation-duration:1.2s;"]);
}, function (props) {
  return props.transitionSpeed === 'medium' && css(["animation-duration:0.9s;"]);
}, function (props) {
  return props.transitionSpeed === 'fast' && css(["animation-duration:0.6s;"]);
}, function (props) {
  return props.previouslyActive && css(["display:flex;visibility:hidden;order:2;", " ", ""], props.slideAwayToDirection === 'left' && css(["animation-name:", ";"], slideToTheLeft), props.slideAwayToDirection === 'right' && css(["animation-name:", ";"], slideToTheRight));
}, function (props) {
  return props.active && css(["display:flex;visibility:visible;order:1;", " ", ""], props.slidingFromDirection === 'left' && css(["animation-name:", ";"], slideFromTheLeft), props.slidingFromDirection === 'right' && css(["animation-name:", ";"], slideFromTheRight));
});
var Inner = styled.div.withConfig({
  displayName: "Sliderstyles__Inner",
  componentId: "sc-1w0ebdo-2"
})(["display:flex;height:auto;", ""], function (props) {
  return css(["align-items:", ";"], props.innerAlignment);
});
var Nav = styled.div.withConfig({
  displayName: "Sliderstyles__Nav",
  componentId: "sc-1w0ebdo-3"
})(["display:flex;justify-content:center;align-items:center;margin:10px 0 20px;height:40px;"]);
var NavButton = styled.div.withConfig({
  displayName: "Sliderstyles__NavButton",
  componentId: "sc-1w0ebdo-4"
})(["background:", ";border:0;height:15px;min-width:15px;border-radius:50%;outline:none;position:relative;padding:0;margin:0 10px;cursor:pointer;&:hover{transition:all 0.25s ease-in;opacity:0.65;}", " ", " ", ""], function (props) {
  return props.theme.color.monochrome.light;
}, function (props) {
  return props.active && css(["cursor:default;opacity:1;transition:all 0.25s ease-in;background:", ";"], props.theme.color.palette['brand-1']);
}, function (props) {
  return props.size === 'sm' && css(["height:8px;width:8px;margin:0 3px;"]);
}, function (props) {
  return props.size === 'lg' && css(["height:24px;width:24px;margin:0 12px;"]);
});
var NavChevron = styled.button.withConfig({
  displayName: "Sliderstyles__NavChevron",
  componentId: "sc-1w0ebdo-5"
})(["background:", ";border:0;height:40px;width:40px;border-radius:50%;outline:none;position:relative;margin:0 20px;cursor:pointer;", " &:focus{outline:-webkit-focus-ring-color auto 5px;}svg{display:block;margin:auto;}", ""], function (props) {
  return props.theme.color.monochrome.white;
}, function (props) {
  return props.navStyle === 'withSlideCount' && css(["background:rgba(255,255,255,0.5);border:1px solid ", ";"], props.theme.color.monochrome.light);
}, function (props) {
  return props.disabled && css(["opacity:0.4;pointer-events:none;"]);
});
var NavChevronIcon = styled(ChevronIcon).withConfig({
  displayName: "Sliderstyles__NavChevronIcon",
  componentId: "sc-1w0ebdo-6"
})(["fill:", ";.icon__line{stroke-width:15;}"], function (props) {
  return props.theme.channel !== 'sainsburys' && props.theme.color.palette['brand-1'];
});
var NavWithCountLabel = styled.div.withConfig({
  displayName: "Sliderstyles__NavWithCountLabel",
  componentId: "sc-1w0ebdo-7"
})(["background:", ";font-size:14px;height:20px;line-height:20px;margin-bottom:15px;text-align:center;"], function (props) {
  return props.theme.color.monochrome.lighter;
});
var NavWithCountArrows = styled.div.withConfig({
  displayName: "Sliderstyles__NavWithCountArrows",
  componentId: "sc-1w0ebdo-8"
})(["bottom:0;display:flex;height:40px;justify-content:space-between;margin:auto;position:absolute;top:-35px;width:100%;"]);
export { Slider, Slide, Inner, Nav, NavButton, NavChevron, NavChevronIcon, NavWithCountLabel, NavWithCountArrows };